import { render } from "./MobileIotView.vue?vue&type=template&id=8d0b8ade&scoped=true"
import script from "./MobileIotView.vue?vue&type=script&lang=js"
export * from "./MobileIotView.vue?vue&type=script&lang=js"

import "./MobileIotView.vue?vue&type=style&index=0&id=8d0b8ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0b8ade"]])

export default __exports__